'use client';

import { c as _c } from "react/compiler-runtime";
import { isRunnerBehind } from '@shared/all/helpers/runningJobs';
import { useRunnerAttention } from '@shared/utils/hooks/useRunnerAttention';
import { useRunner } from './useRunnerContext';
import { useRunners } from './useRunners';

/**
 * The runner badge for the provider's picked runner (the board header, the
 * terminal window's runner menu). `active` false limits the list to
 * `offline`: the menu can show a runner other than the provider's pick, and
 * that runner's state is not this provider's to report.
 */
export function useBoardRunnerAttention(t0) {
  const $ = _c(30);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    offline: t2,
    active: t3
  } = t1;
  const offline = t2 === undefined ? false : t2;
  const active = t3 === undefined ? true : t3;
  const {
    agent,
    runners,
    selectedRunner,
    config
  } = useRunner();
  const {
    versions,
    latestVersion,
    requestUpdate
  } = useRunners();
  let t4;
  if ($[2] !== runners || $[3] !== selectedRunner) {
    let t5;
    if ($[5] !== selectedRunner) {
      t5 = r => r.socketId === selectedRunner;
      $[5] = selectedRunner;
      $[6] = t5;
    } else {
      t5 = $[6];
    }
    t4 = runners.find(t5);
    $[2] = runners;
    $[3] = selectedRunner;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const selected = t4;
  const isOwner = !selected?.shared;
  const version = selected ? versions[selected.runnerId] : undefined;
  let t5;
  if ($[7] !== active || $[8] !== isOwner || $[9] !== latestVersion || $[10] !== version) {
    t5 = active && isOwner && !!version && !!latestVersion && isRunnerBehind(version, latestVersion);
    $[7] = active;
    $[8] = isOwner;
    $[9] = latestVersion;
    $[10] = version;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  const updateAvailable = t5;
  const t6 = active ? agent : null;
  const t7 = active && config.setup.phase === "error";
  let t8;
  if ($[12] !== config.baseline.mainBranch || $[13] !== config.baseline.repoUrl || $[14] !== config.hasGithubToken || $[15] !== config.setup.phase) {
    t8 = [config.baseline.repoUrl, config.baseline.mainBranch, config.hasGithubToken, config.setup.phase];
    $[12] = config.baseline.mainBranch;
    $[13] = config.baseline.repoUrl;
    $[14] = config.hasGithubToken;
    $[15] = config.setup.phase;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  const t9 = t8.join("|");
  let t10;
  if ($[17] !== isOwner || $[18] !== offline || $[19] !== t6 || $[20] !== t7 || $[21] !== t9 || $[22] !== updateAvailable) {
    t10 = {
      agent: t6,
      isOwner,
      offline,
      setupFailed: t7,
      updateAvailable,
      refreshKey: t9
    };
    $[17] = isOwner;
    $[18] = offline;
    $[19] = t6;
    $[20] = t7;
    $[21] = t9;
    $[22] = updateAvailable;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  const attention = useRunnerAttention(t10);
  let t11;
  if ($[24] !== requestUpdate || $[25] !== selected) {
    t11 = () => {
      if (selected) {
        requestUpdate(selected.socketId);
      }
    };
    $[24] = requestUpdate;
    $[25] = selected;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  let t12;
  if ($[27] !== attention || $[28] !== t11) {
    t12 = {
      ...attention,
      requestUpdate: t11
    };
    $[27] = attention;
    $[28] = t11;
    $[29] = t12;
  } else {
    t12 = $[29];
  }
  return t12;
}